export const STRIPE_LINKS = {
  AU: 'https://pay.businesskitz.com.au',
  SANDBOX: 'https://buy.stripe.com',
};

export const PRODUCT_PLANS_LINKS = {
  TEST: {
    BUSINESS_STARTER: `${STRIPE_LINKS.SANDBOX}/test_cNi6oI1jN7AI6Ir2EXdZ600`,
    BUSINESS_ESSENTIALS: `${STRIPE_LINKS.SANDBOX}/test_7sY6oI4vZ9IQgj193ldZ60g`,
    BUSINESS_ESSENTIALS_ESSA: `${STRIPE_LINKS.SANDBOX}/test_14A14o8Mf08g9UDa7pdZ60o`,
    BUSINESS_GROWTH: `${STRIPE_LINKS.SANDBOX}/test_3cI9AU7Ib9IQ0k393ldZ60f`,
    BUSINESS_STARTER_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_8x2dRafaDbQY5EngvNdZ601`,
    BUSINESS_GROWTH_ESSA: `${STRIPE_LINKS.SANDBOX}/test_9B6aEYaUn4oweaTenFdZ60p`,
    BUSINESS_ESSENTIALS_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_aFadRa8Mf08g6Ir4N5dZ60e`,
    BUSINESS_GROWTH_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_8x2aEY7Ib2go5En0wPdZ60d`,
    APA_DISCOUNTED_ESSENTIALS: `${STRIPE_LINKS.SANDBOX}/test_00wcN66E708g5En93ldZ60h`,
    APA_FREE_ESSENTIALS: `${STRIPE_LINKS.SANDBOX}/test_7sY6oI4vZ9IQgj193ldZ60g`,
    APA_FREE_GROWTH: `${STRIPE_LINKS.SANDBOX}/test_3cI9AU7Ib9IQ0k393ldZ60f`,
    ESIGN_ONLY: `${STRIPE_LINKS.SANDBOX}/test_4gM5kEgeHbQY9UDfrJdZ60k`,
    ESIGN_ONLY_ESSA: `${STRIPE_LINKS.SANDBOX}/test_28EfZie6z5sA5En6VddZ60q`,
    ESIGN_ONLY_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_4gMfZi4vZaMUd6P1ATdZ60l`,
  },
  PROD: {
    BUSINESS_STARTER: `${STRIPE_LINKS.AU}/b/3cI3cwbPC4eUfmafEhawo0k`,
    BUSINESS_ESSENTIALS: `${STRIPE_LINKS.AU}/b/3cI7sMf1O3aQfmagIlawo0u`,
    BUSINESS_ESSENTIALS_ESSA: `${STRIPE_LINKS.AU}/b/fZueVe3j68va1vkajXawo0E`,
    BUSINESS_GROWTH: `${STRIPE_LINKS.AU}/b/28E4gAdXK4eU0rgcs5awo0t`,
    BUSINESS_GROWTH_ESSA: `${STRIPE_LINKS.AU}/b/bJeaEY2f2bHmc9YajXawo0F`,
    BUSINESS_STARTER_ANNUAL: `${STRIPE_LINKS.AU}/b/14A14of1O26Ma1Qbo1awo0p`,
    BUSINESS_ESSENTIALS_ANNUAL: `${STRIPE_LINKS.AU}/b/8x2fZidXKaDiei60Jnawo0w`,
    BUSINESS_GROWTH_ANNUAL: `${STRIPE_LINKS.AU}/b/14AcN6dXK9zegqecs5awo0v`,
    APA_DISCOUNTED_ESSENTIALS: `${STRIPE_LINKS.AU}/b/3cI7sMf1O3aQfmagIlawo0u`,
    APA_FREE_ESSENTIALS: `${STRIPE_LINKS.AU}/b/3cI7sMf1O3aQfmagIlawo0u`,
    APA_FREE_GROWTH: `${STRIPE_LINKS.AU}/b/28E4gAdXK4eU0rgcs5awo0t`,
    ESIGN_ONLY: `${STRIPE_LINKS.AU}/b/8x28wQ5re26M0rg8bPawo0B`,
    ESIGN_ONLY_ESSA: `${STRIPE_LINKS.AU}/b/4gMdRa7zm4eU5LA63Hawo0D`,
    ESIGN_ONLY_ANNUAL: `${STRIPE_LINKS.AU}/b/4gM7sMbPCh1G3Ds2Rvawo0C`,
  },
};
